import React from 'react';
import { useDispatch } from 'react-redux';
import { useLanguagePreference } from './useLanguagePreference';
import { useLocalizeMutation } from '../../../api/useLocalizeMutation';
import { ListItem } from '../../../../CommonComponents/OPL/List/ListItem';
import { showError } from '../../../../CommonComponents/ToastMessenger/ToastMessengerActions';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';
import { Loading } from '../../../../CommonComponents/OPL/Loading/Loading';
import { MESSAGES } from '../../../../CommonConstants';
import {
  Menu,
  MenuContent,
  MenuItem,
  MenuSeparator,
  MenuTriggerItem,
} from '../../../../CommonComponents/OPL/Menu/Menu';

interface Props {
  clientId: string;
}

export const LanguagePreference: React.FC<Props> = ({ clientId }) => {
  const { data, isFetching } = useLanguagePreference(clientId);

  const { mutateAsync: switchLanguage } = useLocalizeMutation();

  const dispatch = useDispatch();

  const onLanguageClick = language => {
    if (language.selected) {
      return;
    }

    try {
      Localize.setLanguage(language.code);

      switchLanguage({
        clientId,
        languagePreference: language.value,
      });
    } catch {
      dispatch(showError(new Error(MESSAGES.GENERIC_ERROR)));
    }
  };

  if (isFetching) {
    return (
      <Box py="16" justifyContent="center" display="flex">
        <Loading size="small" />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  const { currentLanguage, languageOptions } = data;

  return (
    <>
      <Menu>
        <MenuTriggerItem>
          <ListItem icon="far fa-globe">{currentLanguage}</ListItem>
        </MenuTriggerItem>

        <MenuContent sideOffset={0}>
          {languageOptions.map(option => (
            <MenuItem key={option.code} onSelect={() => onLanguageClick(option)}>
              <ListItem icon="far fa-check" variant={option.selected ? 'selected' : 'inactive'}>
                {option.text}
              </ListItem>
            </MenuItem>
          ))}
        </MenuContent>
      </Menu>

      <MenuSeparator />
    </>
  );
};
